import { render, staticRenderFns } from "./banner-login.vue?vue&type=template&id=14616a84&scoped=true&"
import script from "./banner-login.vue?vue&type=script&lang=js&"
export * from "./banner-login.vue?vue&type=script&lang=js&"
import style0 from "./banner-login.vue?vue&type=style&index=0&id=14616a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14616a84",
  null
  
)

export default component.exports